import { PlaidAccount } from "react-plaid-link";

/**
 * A v3 external bank account is either Checking or Savings
 * (`ExternalBankAccountAccountType`), so `POST /external-bank-accounts`
 * rejects a depository account of any other subtype — `cash management`,
 * `hsa`, `prepaid`, … — with a 422. Plaid Link pre-selects every account it
 * finds, so the common selection (checking + savings + cash management) always
 * carried one guaranteed failure; dropping the known-unsupported subtypes
 * before the create keeps that case from erroring at all.
 *
 * Only the depository subtypes we know the API refuses are filtered out.
 * Anything else — a missing subtype, a non-depository type such as a credit
 * card (still linked by bookkeeping) — is left for the API to accept or
 * reject, rather than being hidden by the client.
 */
const LINKABLE_DEPOSITORY_SUBTYPES = ["checking", "savings"];

export const selectorPlaidAccountLinkable = (plaidAccount: PlaidAccount) => {
  const type = plaidAccount.type?.toLowerCase();
  const subtype = plaidAccount.subtype?.toLowerCase();

  if (type !== "depository" || !subtype) {
    return true;
  }

  return LINKABLE_DEPOSITORY_SUBTYPES.includes(subtype);
};
